import { Component, Vue, Watch } from 'vue-property-decorator'
import { debounce } from '@/utils/util'
import AreaApi from '@/api/area'
const debounceSearch = debounce(300)

@Component({})
export default class AreaSearchTree extends Vue {
	public areaResult: any = []
	public areaSearchValue: string = ''
	// 是否需要“全部”选项
	public needQuanBu = true
	public currentAreaTree: any = []

	public setAreaAsTree() {
		if (this.needQuanBu) {
			this.areaResult = [
				{
					value: '',
					key: '',
					title: '全部',
					isLeaf: true,
				},
			].concat(this.currentAreaTree)
		} else {
			this.areaResult = this.currentAreaTree
		}
	}

	public searchArea(val: string) {
		debounceSearch(() => {
			if (!val) {
				this.setAreaAsTree()
				return
			}
			AreaApi.searchArea(val.trim()).then((res: any) => {
				let province: any = {}
				let city: any = {}
				this.areaResult = []
				res.data.forEach((it: any) => {
					province[it.provCode] = it
					city[it.cityCode] = it
				})
				console.log(res.data)
				for (const key in province) {
					this.areaResult.push({
						isLeaf: true,
						key: province[key].provCode,
						title: province[key].provName,
						value: province[key].provCode,
					})
				}

				for (const key in city) {
					this.areaResult.push({
						isLeaf: true,
						key: city[key].cityCode,
						title: city[key].cityName,
						value: city[key].cityCode,
					})
				}

				res.data.forEach((item: any) => {
					this.areaResult.push({
						isLeaf: true,
						key: item.areaCode,
						title: item.provName + '-' + item.cityName + '-' + item.areaName,
						value: item.areaCode,
					})
				})
				console.log(this.areaResult)
			})
		})
	}

	public initAreaTree() {
		this.$store.dispatch('setting/initAreas').then((res: any) => {
			this.currentAreaTree = this.$store.state.setting.areas
			this.setAreaAsTree()
			console.log('-----')
			this.$emit('initTreeCb')
		})
	}

	public activated() {
		// this.initAreaTree()
	}

	public created() {
		// console.log("created")
		this.initAreaTree()
	}
}
